import {
  Avatar,
  Card,
  Text,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";

export default function PersonCard({
  indx,
  name,
  imageName,
  position,
  description,
}: {
  indx: number;
  name: string;
  imageName: string;
  position: string;
  description: string;
}) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");
  let color = "darkblue";
  let color2: string | undefined;
  switch (position) {
    case "Co-founder":
      color = "darkblue";
      break;
    case "AV Editor":
      break;
    case "Biology":
    case "Chemistry":
    case "Physics":
      color = position.toLowerCase();
      break;
    default:
      const subjects = position.split(" & ");
      color = subjects[0].toLowerCase();
      color2 = subjects[1].toLowerCase();
      break;
  }

  const avatarBackgroundImage = `linear-gradient(white, white), linear-gradient(to right, ${
    theme.colors[color][5]
  }, ${theme.colors[color2 ?? color][5]})`;

  return (
    <Card
      padding="xl"
      radius="md"
      style={{
        overflow: "visible",
        boxShadow: "var(--mantine-shadow-sm)",
      }}
      mt={100}
    >
      <Avatar
        src={`/static/images/team/${imageName}200_bw.png`}
        size={100}
        radius={100}
        mx="auto"
        mt={-80}
        style={{
          border: "solid 2px transparent",
          borderRadius: theme.radius.lg,
          backgroundImage: avatarBackgroundImage,
          backgroundOrigin: "border-box",
          backgroundClip: "content-box, border-box",
        }}
        alt={`${name} display picture`}
      />
      <Text
        size="1.4rem"
        ta="center"
        fw={500}
        mt="md"
        c={
          colorScheme === "dark"
            ? theme.colors.lightblue[5]
            : theme.colors.darkblue[5]
        }
      >
        {name}
      </Text>
      <Text
        ta="center"
        c={
          colorScheme === "dark"
            ? theme.colors.dark[1]
            : theme.colors.dark[3]
        }
        size={"sm"}
        lh={1}
      >
        {position}
      </Text>
      <Text
        ta="center"
        mt="xl"
        c={
          colorScheme === "dark"
            ? theme.colors.dark[0]
            : theme.colors.dark[3]
        }
      >
        {description}
      </Text>
    </Card>
  );
}
